import React, { useState } from "react";
import { FcMenu } from 'react-icons/fc';

const NavBarItem = ({ title, classprops, link }) => (
  <li className={`my-2 ${classprops}`}>
    <a
      href={link || "#"}
      onClick={(e) => { if (!link) e.preventDefault(); }}
      target={link ? "_blank" : undefined}
      rel={link ? "noreferrer" : undefined}
      className="text-xl font-bold text-white block px-4 py-2"
    >
      {title}
    </a>
  </li>
);

const Navbar = () => {
  
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    setMenuVisible(prevState => !prevState);
  };

                   

  return (
    <nav className="w-full md:justify-left items-left p-12"> {/* Updated this line */}

      <div className="flex justify-between items-center">
        
        {/* New relative positioned container */}
        <div className="relative">
          <FcMenu size={40} onClick={toggleMenu} className="cursor-pointer" />
          
          {menuVisible && (
              <div className="bg-gray-700 rounded-lg p-4 absolute top-12 left-0 z-50">
                <ul className="list-none">
                  <NavBarItem
                    title="Images"
                    classprops="hover:bg-gray-600"
                    link="https://deepreal.pmoexperts.online/"
                  />

                  <NavBarItem
                    title="Videos"
                    classprops="hover:bg-gray-600"
                    link="https://deepreal.pmoexperts.online/videos/"
                  />
                </ul>
              </div>
            )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;



